export default () => (
  <svg aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    height="20"
    width="20"
  >
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    >
      <path d="M1 5h30v22H1z" strokeWidth="2" />
      <path
        d="M16 20v-8l-2 4-2-4v8M24 12l3 8M27 12l-3 8M21 20h-.4a1.6 1.6 0 01-1.6-1.6v-4.8a1.6 1.6 0 011.6-1.6h.4M19 17h2M5 17h4M9 20v-6a2 2 0 00-4 0v6"
        strokeWidth="2"
      />
    </g>
  </svg>
);
